import React, { createContext, useState } from "react";

interface StatisticsActionContextType {    
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
}

export const StatisticsActionContext = createContext<StatisticsActionContextType>({    
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},  
});

interface StatisticsActionProviderProps {
  children: React.ReactNode;
}

export const StatisticsActionProvider: React.FC<StatisticsActionProviderProps> = ({
  children,
}) => {  
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);  

  const value = {        
    showModal,
    setShowModal,
    element,
    setElement,    
  };
  return (
    <StatisticsActionContext.Provider value={value}>      
      {children}
    </StatisticsActionContext.Provider>
  );
};
